import React, { Component, PropTypes } from 'react';
import './Button.css';

class Button extends Component {
  /**
   * A default click handler. Only used to provide a fallback if you don't
   * pass in a valid onClick() handler.
   *
   * @memberOf Button
   */
  onClick() {  }

  render() {
    let classNames = ['Button'];

    if (this.props.buttonStyle) {
      let styles = this.props.buttonStyle.split(' ');
      styles.forEach((style) => classNames.push(`Button--${style}`));
    }

    if (this.props.className) {
      classNames.push(this.props.className);
    }

    return (
      <button onClick={this.props.onClick || this.onClick} className={classNames.join(' ')}>{this.props.children}</button>
    );
  }
}

Button.propTypes = {
  onClick: PropTypes.func
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button.js